import { computed, ComputedRef } from 'vue'

import { findSubParticipantWithStat } from '@collector/shared-domain'
import {
  BaseballSubParticipantStatId,
  SubParticipantPosition,
} from '@collector/sportsapi-client-legacy'
import { SubParticipant } from '@collector/sportsapi-types'
import { useInvertedSubParticipants } from '@desktop/views/Relation/composables'
import { IncidentPlayerOption } from '@desktop/views/Relation/types'

import { useInvertedIncidentPlayers } from '../../composables'
import { useEventDetailHalf } from './useEventDetailHalf'
import { usePitcherBatterOptions } from './usePitcherBatterOptions'

export function useBatterOptions(): {
  batterOptions: ComputedRef<IncidentPlayerOption[]>
  currentBatter: ComputedRef<SubParticipant | null>
} {
  // composables
  const { firstSubParticipants, secondSubParticipants } =
    useInvertedSubParticipants()
  const { firstTeamPlayersOptions, secondTeamPlayersOptions } =
    useInvertedIncidentPlayers()
  const { eventDetailHalfValue } = useEventDetailHalf()

  // data
  const isTopHalf = eventDetailHalfValue.value === 'top'

  const battingSubparticipants = computed(() =>
    isTopHalf ? secondSubParticipants.value : firstSubParticipants.value,
  )

  const battingPlayersOptions = computed(() =>
    isTopHalf ? secondTeamPlayersOptions.value : firstTeamPlayersOptions.value,
  )

  const currentBatter = computed(() =>
    findSubParticipantWithStat(
      battingSubparticipants.value,
      BaseballSubParticipantStatId.CurrentBatter,
    ),
  )

  const batterOptions = usePitcherBatterOptions(
    battingPlayersOptions,
    currentBatter,
    [SubParticipantPosition.Batter, SubParticipantPosition.Pitcher],
  )

  return {
    batterOptions,
    currentBatter,
  }
}
